/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IntegrationStatusResponse } from '../../models/integration-status-response';

export interface GetSegmentIntegrations$Params {
  'Active-Tenant-Identifier': string;
}

export function getSegmentIntegrations(http: HttpClient, rootUrl: string, params: GetSegmentIntegrations$Params, context?: HttpContext): Observable<StrictHttpResponse<IntegrationStatusResponse>> {
  const rb = new RequestBuilder(rootUrl, getSegmentIntegrations.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IntegrationStatusResponse>;
    })
  );
}

getSegmentIntegrations.PATH = '/segment-integrations/integrations';
